import React from "react";

export const Inline = (props: React.PropsWithChildren<{}>): JSX.Element => {
    return (
        <div style={{ display: "inline" }}>
            {props.children}
        </div>
    );
};
